/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {publishShiftSchedule} from '../api'

export const useMutationPublishShiftSchedule = createReactQueryMutationHook('publishShiftSchedule', publishShiftSchedule)
